// International dialing prefixes. Country display names are resolved at runtime
// via Intl.DisplayNames in the current UI language; flags via flagcdn.com.
// Ordered groups: popular first, then rest of Europe, then rest of world.

export const DIAL = {
  IT: "+39", GB: "+44", FR: "+33", DE: "+49", US: "+1",
  ES: "+34", PT: "+351", CH: "+41", AT: "+43", NL: "+31", BE: "+32", LU: "+352",
  IE: "+353", DK: "+45", SE: "+46", NO: "+47", FI: "+358", IS: "+354",
  PL: "+48", CZ: "+420", SK: "+421", HU: "+36", RO: "+40", BG: "+359", GR: "+30",
  HR: "+385", SI: "+386", RS: "+381", UA: "+380", RU: "+7", EE: "+372", LV: "+371",
  LT: "+370", MT: "+356", CY: "+357", AL: "+355", BA: "+387", MK: "+389", ME: "+382",
  MD: "+373", LI: "+423", MC: "+377", AD: "+376", SM: "+378", TR: "+90",
  CA: "+1", MX: "+52", BR: "+55", AR: "+54", CL: "+56", CO: "+57",
  AU: "+61", NZ: "+64", JP: "+81", CN: "+86", KR: "+82", IN: "+91", ID: "+62",
  TH: "+66", VN: "+84", PH: "+63", MY: "+60", SG: "+65", HK: "+852",
  AE: "+971", SA: "+966", QA: "+974", IL: "+972",
  ZA: "+27", EG: "+20", MA: "+212", NG: "+234", KE: "+254",
};

export const POPULAR = ["IT", "GB", "FR", "DE", "US"];

export const EUROPE = [
  "ES", "PT", "CH", "AT", "NL", "BE", "LU", "IE", "DK", "SE", "NO", "FI", "IS",
  "PL", "CZ", "SK", "HU", "RO", "BG", "GR", "HR", "SI", "RS", "UA", "RU", "EE",
  "LV", "LT", "MT", "CY", "AL", "BA", "MK", "ME", "MD", "LI", "MC", "AD", "SM", "TR",
];

export const WORLD = [
  "CA", "MX", "BR", "AR", "CL", "CO", "AU", "NZ", "JP", "CN", "KR", "IN", "ID",
  "TH", "VN", "PH", "MY", "SG", "HK", "AE", "SA", "QA", "IL", "ZA", "EG", "MA", "NG", "KE",
];

export const flagUrl = (iso) => `https://flagcdn.com/24x18/${iso.toLowerCase()}.png`;

const nameCache = {};
export const countryName = (iso, lang = "it") => {
  const key = `${lang}:${iso}`;
  if (nameCache[key]) return nameCache[key];
  let name = iso;
  try {
    name = new Intl.DisplayNames([lang], { type: "region" }).of(iso) || iso;
  } catch (e) { /* fallback to ISO */ }
  nameCache[key] = name;
  return name;
};
